import { RelaySwitchScheduleEventDeviceConfig } from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class RelaySwitchFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): RelaySwitchScheduleEventDeviceConfig {
    return {
      '@type': 'RELAY_SWITCH',
      deviceCommand: 'RELAY_SWITCH',
      deviceNumbers,
      requiredStates: [],
    };
  }
}
